"use client";

import { useState, useRef, useEffect } from "react";
import { Icons } from "../assets/icons/Icons";

const SwipeToDeleteItem = ({
    children,
    onDelete,
    id,
    rightContent = "Delete",
    rightContentClassName = "bg-danger",
    rightContentWidth = 60,
    deleteThreshold = 50,
}) => {
    const [isDragging, setIsDragging] = useState(false);
    const [dragStartX, setDragStartX] = useState(0);
    const [position, setPosition] = useState(0);
    const itemRef = useRef(null);

    const handleMouseDown = (e) => {
        setIsDragging(true);
        setDragStartX(e.clientX || e.touches[0].clientX);
    };

    const handleMouseMove = (e) => {
        if (isDragging) {
            const clientX = e.clientX || e.touches[0].clientX;
            const moveDistance = dragStartX - clientX;

            if (Math.abs(moveDistance) > 20) {
                setPosition(rightContentWidth);
                setIsDragging(false);
            } else {
                setPosition(0);
            }
        }
    };

    const handleMouseUp = () => {
        setIsDragging(false);

        if (position >= deleteThreshold) {
            setPosition(rightContentWidth);
        } else {
            setPosition(0);
        }
    };

    const handleClick = () => {
        if (position === 0) {
            setPosition(rightContentWidth);
        } else {
            setPosition(0);
        }
    };

    const handleOutsideClick = (e) => {
        if (itemRef.current && !itemRef.current.contains(e.target)) {
            setPosition(0);
        }
    };

    useEffect(() => {
        document.addEventListener("click", handleOutsideClick);
        return () => {
            document.removeEventListener("click", handleOutsideClick);
        };
    }, []);

    return (
        <div
            ref={itemRef}
            className="position-relative mb-3"
            onClick={handleClick}
            onMouseDown={handleMouseDown}
            onTouchStart={handleMouseDown}
            style={{ touchAction: "pan-y" }}
        >
            <div
                className="w-100"
                style={{
                    transform: `translateX(-${position}px)`,
                    transition: "transform 0.3s ease-out",
                    zIndex: 2,
                    position: "relative",
                    cursor: "grab",
                }}
            >
                {children}
            </div>

            {position >= deleteThreshold && (
                <div
                    className={`position-absolute top-0 end-0 bottom-0 d-flex align-items-center justify-content-center ${rightContentClassName}`}
                    style={{
                        width: `${rightContentWidth}px`,
                        right: 0,
                        zIndex: 1,
                        borderTopRightRadius: "12px",
                        borderBottomRightRadius: "12px",
                        cursor: "pointer",
                    }}
                    onClick={(e) => {
                        e.stopPropagation();
                        onDelete(id);
                    }}
                >
                    <Icons.DeleteIcon />
                </div>
            )}
        </div>
    );
};

export default SwipeToDeleteItem;
